import { Box } from '@mantine/core'
import React, { type PropsWithChildren } from 'react'

import classes from './styles.module.css'

export function WrapperFooter({ children }: PropsWithChildren) {
  return <Box className={classes.wrapperFooter}>{children}</Box>
}

WrapperFooter.displayName = 'ModalWrapperFooter'
